// Html
import HtmlRender from "@/components/posts/html/HtmlRender.vue";
// Grab
import GrabRender from "@/components/posts/grab/GrabRender.vue";
// Rss
import RssRender from "@/components/posts/rss/RssRender.vue";
// Date
import DateRender from "@/components/posts/date/DateRender.vue";
// Image
import ImageRender from "@/components/posts/image/ImageRender.vue";
// Video
import VideoRender from "@/components/posts/video/VideoRender.vue";
// MeetingList
import MeetingListRender from "@/components/posts/meetingList/MeetingListRender.vue";
// Clock
import ClockRender from "@/components/posts/clock/ClockRender.vue";
// Wayfinder
import WayfinderRender from "@/components/posts/wayfinder/WayfinderRender.vue";
// FixedHtml
import FixedHtmlRender from "@/components/posts/fixedHtml/FixedHtmlRender.vue";

import { Component } from "vue";

// constants
export const renderSufix = "Render";

// postTypes data structure
export const postTypes = {
    Grab: {
        RenderComponent: GrabRender
    },
    Html: {
        RenderComponent: HtmlRender
    },
    RSS: {
        RenderComponent: RssRender
    },
    MeetingList: {
        RenderComponent: MeetingListRender
    },
    Date: {
        RenderComponent: DateRender
    },
    Image: {
        RenderComponent: ImageRender
    },
    Video: {
        RenderComponent: VideoRender
    },
    Clock: {
        RenderComponent: ClockRender
    },
    Wayfinder: {
        RenderComponent: WayfinderRender
    },
    FixedHtml: {
        RenderComponent: FixedHtmlRender
    }
};

// methods

// IE11 entries implementation
if (!Object.entries) {
    Object.entries = function (obj: any) {
        const ownProps = Object.keys(obj);
        const ownValues = Object.keys(obj).map(e => obj[e]);
        let i = ownProps.length;
        const resArray = new Array(i); // preallocate the Array
        while (i--) { resArray[i] = [ownProps[i], ownValues[i]]; }

        return resArray;
    };
}

function renderComponentsFn() {
    const components: { [key: string]: Component } = {};
    for (const [key, value] of Object.entries(postTypes)) {
        components[key.concat(renderSufix)] = value.RenderComponent;
    }
    return components;
}

export const renderComponents = renderComponentsFn();
